<template>
    <div v-if="config">
        This is the future.
    </div>
</template>

<script>
export default {
    props: ["config"]
};
</script>